import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Paper,
} from "@mui/material";

const TermsPage = () => {
  const sections = [
    {
      title: "1. Acceptance of Terms",
      content:
        "By registering for an account or utilizing our Services, you acknowledge that you have thoroughly read, comprehended, and agree to be bound by these Terms. Should you disagree with any provision herein, you are advised to refrain from using our Site or Services.",
    },
    {
      title: "2. Eligibility",
      content:
        "You must be at least 18 years of age and possess the legal capacity to enter into these Terms. By accessing and using the Site, you hereby represent and warrant that you meet these stipulated requirements.",
    },
    {
      title: "3. Account Registration",
      content:
        "To access certain features of our Services, you are required to create an account by providing accurate, current, and complete information. You are solely responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.",
    },
    {
      title: "4. Services Provided",
      content:
        "VastuPlan offers a comprehensive range of Vastu consultation services, including but not limited to instant Vastu reports, personalized Vastu consultations, and detailed floor plan analysis. These services are delivered through a harmonious blend of traditional Vedic insights and contemporary methodologies.",
    },
    {
      title: "5. Fees and Payment",
      content:
        "VastuPlan reserves the unequivocal right to determine, announce, and modify the fees for any Services offered on our Site at any given time without prior notice. All fees are payable in advance and are non-refundable unless explicitly stated otherwise in writing by the Company.",
    },
    {
      title: "6. Intellectual Property",
      content:
        "All content displayed on this Site, including but not limited to text, graphics, logos, images, and software, is the exclusive property of the Company or its licensors and is safeguarded by intellectual property laws. Unauthorized reproduction, distribution, or creation of derivative works is strictly prohibited without our prior written consent.",
    },
  ];

  return (
    <Box sx={{ minHeight: "100vh", bgcolor: "#f8f9fa" }}>
      <Container maxWidth="lg" sx={{ pt: 8, pb: 8 }}>
        <Paper
          elevation={0}
          sx={{ p: { xs: 3, md: 6 }, bgcolor: "white", borderRadius: 2 }}
        >
          <Box sx={{ maxWidth: 900, mx: "auto" }}>
            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{
                color: "#bb0000",
                fontWeight: 700,
                mb: 3,
                textAlign: "center",
                position: "relative",
                "&:after": {
                  content: '""',
                  position: "absolute",
                  bottom: -12,
                  left: "50%",
                  transform: "translateX(-50%)",
                  width: "80px",
                  height: "4px",
                  bgcolor: "#bb0000",
                  borderRadius: "2px",
                },
              }}
            >
              Terms and Conditions
            </Typography>

            <Divider sx={{ mb: 4, mt: 4 }} />

            <Box
              sx={{ mb: 6, display: "flex", flexDirection: "column", gap: 2 }}
            >
              <Typography
                variant="subtitle1"
                sx={{
                  color: "#666666",
                  textAlign: "center",
                }}
              >
                Last Updated: February 13, 2025
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  color: "#555555",
                  lineHeight: 1.8,
                  mb: 2,
                }}
              >
                Welcome to VastuPlan.com. These Terms and Conditions ("Terms")
                govern your use of our Site and the services provided therein.
                VastuPlan is a service offered under Structure Design and
                Services Pvt. Ltd., operating under its premium home brand
                GharKarma ("Company", "we", "us", or "our").
              </Typography>
            </Box>

            <Grid container spacing={4}>
              {sections.map((section) => (
                <Grid item xs={12} key={section.title}>
                  <Card
                    elevation={0}
                    sx={{
                      border: "1px solid rgba(187, 0, 0, 0.1)",
                      borderRadius: 2,
                      transition: "all 0.2s ease",

                      //   "&:hover": {
                      //     borderColor: "rgba(187, 0, 0, 0.3)",
                      //     bgcolor: "#fff",
                      //     boxShadow: "0 4px 20px rgba(187, 0, 0, 0.1)",
                      //   },
                    }}
                  >
                    <CardContent sx={{ p: { xs: 0, md: 4 } }}>
                      <Typography
                        variant="h6"
                        component="h2"
                        gutterBottom
                        sx={{ color: "#bb0000", fontWeight: 600 }}
                      >
                        {section.title}
                      </Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          color: "#555555",
                          lineHeight: 1.8,
                        }}
                      >
                        {section.content}
                      </Typography>
                    </CardContent>
                  </Card>
                </Grid>
              ))}
            </Grid>

            <Divider sx={{ mt: 6, mb: 4 }} />

            <Box sx={{ textAlign: "center" }}>
              <Typography
                variant="body2"
                sx={{
                  color: "#666666",
                }}
              >
                For any questions or concerns regarding these Terms, please
                contact our support team at{" "}
                <Box
                  component="span"
                  sx={{ color: "#bb0000", fontWeight: 500 }}
                >
                  vastuplan@gmail.com
                </Box>
              </Typography>
            </Box>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};

export default TermsPage;
